import gql from 'graphql-tag';

export default gql`
  query GetPlan {
    getPlan {
      id
      image
      google_maps_url
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/plan/get.js